var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKtla(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 124,
    viewBox: "0 0 148 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.2929 54.8135C65.6808 54.8135 57.6813 58.4529 52.6726 64.6147C51.0511 66.6326 49.6457 69.6594 49.0692 71.3891L70.3292 71.353C70.7256 71.353 73.9686 71.3891 74.401 71.4251C74.7974 71.4611 78.0765 71.9296 79.1575 72.398C79.1935 72.434 79.2656 72.4701 79.3376 72.4701H79.3737C83.3734 74.6321 86.2201 78.8841 86.2201 83.7487C86.2201 90.8474 80.3466 96.6128 73.2479 96.6128C66.8699 96.6128 60.3478 92.1446 60.3478 83.7487C60.3478 82.0911 60.4199 80.9741 60.6 79.2805H45.4658C45.2496 80.6498 45.1055 81.9109 45.1055 83.3523C45.1055 99.0631 58.2939 111.711 74.2929 111.711C90.2919 111.711 103.3 98.955 103.3 83.2442C103.3 67.5695 90.2919 54.8135 74.2929 54.8135Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0162 51.7871L94.475 52.2916L98.0784 40.4004L57.7204 40.04L50.5137 60.9397C50.5137 60.9397 58.7294 51.751 72.2421 51.751C72.6745 51.751 82.5838 51.7511 83.0162 51.7871Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M106.724 28.1489L99.5176 14.4561H93.0315L86.7976 25.9869H77.8972V16.6181V14.4561H72.8525H55.9166L46.5478 20.5818V14.4561H44.0254V30.311H46.5478V23.1042L56.6372 30.311H60.601L48.7098 22.0232L56.6372 16.6181H63.844V30.311H66.0061V16.6181H72.8525V30.311H77.8972H90.1488L91.5901 27.4282H100.599L102.4 30.311H106.724V28.1489ZM92.7792 23.8249L96.2745 18.4198L99.1572 23.8249H92.7792Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKtla);
export default __webpack_public_path__ + "static/media/KTLA.7f8f58b9b508bf549c9bdc5a45ca9f30.svg";
export { ForwardRef as ReactComponent };